import React, { useEffect, useState } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from "./AuthContext";
import axios from 'axios';
import { API_ENDPOINTS } from './apiConfig';
import './Layout.css';

const BASE_IMG_URL = API_ENDPOINTS.BASEIMGURL;

function Layout() {
  const location = useLocation();
  const navigate = useNavigate();
  const { token, logout } = useAuth();
  const [profileImg, setProfileImg] = useState(null);
  const [name, setname] = useState(null);



  const handleLogout = () => {
    logout();
    LogoutCall()
    navigate("/");
   
  };

      const LogoutCall = async () => {
      try {
        const res = await axios.post(API_ENDPOINTS.LOGOUT, {}, {
          headers: { token },
        });
      } catch (err) {
        console.error('Error loading profile image:', err);
      }
    };


  useEffect(() => {
    const fetchProfileImg = async () => {
      try {
        const res = await axios.post(API_ENDPOINTS.GETPPHOTO, {}, {
          headers: { token },
        });

        if (res.data.result === 1 && res.data.imgResult === 1) {
          setProfileImg(`${BASE_IMG_URL}${res.data.img}`);
          setname(res.data.name);
        }
      } catch (err) {
        console.error('Error loading profile image:', err);
      }
    };

    if (token || location.state === 1) {
      fetchProfileImg();
    } else {
      setProfileImg(null);
    }
  }, [location.state,token]);

  const collapseNav = () => {
    const nav = document.querySelector('.navbar-collapse');
    if (nav && nav.classList.contains('show')) {
      nav.classList.remove('show');
    }
  };

  const getNavLinkClass = (path) => (
    `nav-link small d-flex align-items-center gap-1 ${
      location.pathname === path ? 'fw-semibold text-warning text-decoration-underline' : 'text-white'
    }`
  );

  return (
    <div className="d-flex flex-column min-vh-100" style={{ background: 'linear-gradient(135deg, #ffe0f0, #d0e8ff)' }}>
      <header>
        <nav className="navbar navbar-expand-lg fixed-top" style={{ backgroundColor: '#ff69b4', zIndex: 1050 }}>
          <div className="container-fluid">
           <Link
      className="navbar-brand fw-bold text-white"
      to="/"
      onClick={collapseNav}
      style={{ display: "flex", alignItems: "center", textDecoration: "none" }}
    >
      <img
        src="/LuvMaryyLogo32.png"
        alt="Luv Marry Logo"
        style={{ marginRight: "6px", height: "32px" }}
      />
      <span
       style={{
          fontFamily: "'Great Vibes', cursive",
          fontSize: window.innerWidth < 768 ? "1.4rem" : "1.5rem",
          letterSpacing: "1px",
          color: "#fff",
          textShadow: "1px 1px 4px rgba(0,0,0,0.5)" // romantic shadow
        }}
      >
        Luv Marry
      </span>
    </Link>
            <button
              className="navbar-toggler bg-light p-1 px-2"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
              style={{ fontSize: '0.8rem', border: '1px solid #ccc', borderRadius: '4px' }}
            >
              <span className="navbar-toggler-icon" style={{ width: '1rem', height: '1rem' }}></span>
            </button>

            <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
              {token ? (
                <ul className="navbar-nav gap-2 align-items-center">
                  <li className="nav-item"><Link to="/search" className={getNavLinkClass('/search')} onClick={collapseNav}><i className="bi bi-house-door-fill"></i> Home</Link></li>
                  <li className="nav-item"><Link to="/ChatScreen" className={getNavLinkClass('/ChatScreen')} onClick={collapseNav}><i className="bi bi-envelope-fill"></i> Messages</Link></li>
                  <li className="nav-item"><Link to="/UpdateDetailsForm" className={getNavLinkClass('/UpdateDetailsForm')} onClick={collapseNav}><i className="bi bi-person-lines-fill"></i> Personal Details</Link></li>
                  <li className="nav-item"><Link to="/DisplayProfileImages" className={getNavLinkClass('/DisplayProfileImages')} onClick={collapseNav}><i className="bi bi-images"></i> Photos</Link></li>
                  <li className="nav-item"><Link to="/ForgotPassword" className={getNavLinkClass('/ForgotPassword')} onClick={collapseNav}><i className="bi bi-lock-fill"></i> Change Password</Link></li>
                  <li className="nav-item"><Link to="/InActiveAccount" className={getNavLinkClass('/InActiveAccount')} onClick={collapseNav}><i className="bi bi-trash3-fill"></i> Delete Account</Link></li>
                  
                  <li className="nav-item">
  <Link
    to="/ContactsUs"
    className={getNavLinkClass('/ContactsUs')}
    onClick={collapseNav}
  >
    <i className="bi bi-headset fs-5"></i>
    <span className="mt-1">Customer Care</span>
  </Link>
</li>

<li className="nav-item">
  <Link
    to="/AboutUs"
    className={getNavLinkClass('/AboutUs')}
    onClick={collapseNav}
  >
    <i className="bi bi-info-circle-fill fs-5"></i>
    <span className="mt-1">About us</span>
  </Link>
</li>

<li className="nav-item">
  <Link
    to="/PrivacyPolicy"
    className={getNavLinkClass('/PrivacyPolicy')}
    onClick={collapseNav}
  >
    <i className="bi bi-shield-lock-fill fs-5"></i>
    <span className="mt-1">Privacy Policy</span>
  </Link>
</li>


                  <li className="nav-item" onClick={collapseNav}><span onClick={handleLogout} className="nav-link text-white small" style={{ cursor: 'pointer' }}><i className="bi bi-box-arrow-right"></i> Logout</span></li>
                </ul>
              ) : (
                <ul className="navbar-nav gap-2">
                  <li className="nav-item"><Link to="/login" className={getNavLinkClass('/login')} onClick={collapseNav}><i className="bi bi-box-arrow-in-right"></i> Login</Link></li>
                  <li className="nav-item"><Link to="/signup" className={getNavLinkClass('/signup')} onClick={collapseNav}><i className="bi bi-person-plus-fill"></i> Signup</Link></li>
                       
    <li className="nav-item">
  <Link
    to="/ContactsUs"
    className={getNavLinkClass('/ContactsUs')}
    onClick={collapseNav}
  >
    <i className="bi bi-headset fs-5"></i>
    <span className="mt-1">Contacts us</span>
  </Link>
</li>

<li className="nav-item">
  <Link
    to="/AboutUs"
    className={getNavLinkClass('/AboutUs')}
    onClick={collapseNav}
  >
    <i className="bi bi-info-circle-fill fs-5"></i>
    <span className="mt-1">About us</span>
  </Link>
</li>

<li className="nav-item">
  <Link
    to="/PrivacyPolicy"
    className={getNavLinkClass('/PrivacyPolicy')}
    onClick={collapseNav}
  >
    <i className="bi bi-shield-lock-fill fs-5"></i>
    <span className="mt-1">Privacy Policy</span>
  </Link>
</li>

                
                </ul>
              )}
            </div>
          </div>
        </nav>

        {token && (
          <div className="w-100 border-bottom d-flex align-items-center justify-content-between px-3 shadow-sm" style={{ height: '48px', marginTop: '56px', position: 'fixed', top: '0', left: 0, zIndex: 1049, background: 'linear-gradient(135deg, #ffe0f0, #d0e8ff)' }}>
            <Link to="/search" onClick={collapseNav} className="d-flex align-items-center gap-2 text-decoration-none overflow-hidden" style={{ maxWidth: '70%' }}>
              {profileImg ? (
                <img src={profileImg} alt="Profile" className="rounded-circle" style={{ width: '32px', height: '32px', objectFit: 'cover', border: '2px solid #ff69b4' }} />
              ) : (
                <div className="rounded-circle d-flex justify-content-center align-items-center" style={{ width: '32px', height: '32px', backgroundColor: '#ccc', color: '#fff', fontSize: '16px' }}>?</div>
              )}
              <span className="fw-semibold text-truncate" style={{ fontSize: '1rem', color: 'rgb(214, 51, 108)' }} title={name}>{name}</span>
            </Link>

            <Link to="/ChatScreen" onClick={collapseNav} className="d-flex align-items-center gap-1 px-2 py-1 rounded-pill text-white text-decoration-none" style={{ backgroundColor: '#ff69b4', fontSize: '0.85rem', fontWeight: '500' }}>
              <i className="bi bi-envelope-fill"></i>
              <span>Messages</span>
            </Link>
          </div>
        )}
      </header>

      <main className="flex-grow-1 px-1 py-5" style={{ paddingTop: '132px' }}>
        <Outlet />
      </main>

      <footer className="bg-white border-top shadow-sm mt-auto">
        <div className="d-flex justify-content-around align-items-center py-2 px-3">
          {!token ? (
            <>
              <Link to="/login" className={getNavLinkClass('/login')} onClick={collapseNav}><i className="bi bi-box-arrow-in-right fs-5"></i><span className="mt-1">Login</span></Link>
              <Link to="/signup" className={getNavLinkClass('/signup')} onClick={collapseNav}><i className="bi bi-person-plus fs-5"></i><span className="mt-1">Signup</span></Link>
            </>
          ) : (
            <>
              <Link to="/support" className={getNavLinkClass('/support')} onClick={collapseNav}><i className="bi bi-headset fs-5"></i><span className="mt-1">Customer Care</span></Link>
              <button className="btn btn-link text-center d-flex flex-column align-items-center small text-muted p-0" onClick={() => { logout(); collapseNav(); }} style={{ textDecoration: 'none' }}>
                <i className="bi bi-box-arrow-right fs-5"></i><span className="mt-1">Logout</span>
              </button>
            </>
          )}
        </div>
      </footer>
    </div>
  );
}

export default Layout;
